<template>
  <a-cascader
    v-model="typeArr"
    :options="typeList"
    :load-data="loadData"
    placeholder="请选择类型"
    change-on-select
    style="width: 180px"
    @change="changeType"
  />
</template>

<script>
export default {
  props: ['feild', 'category'],
  data() {
    return {
      typeArr: [],
      typeList: [],
    }
  },
  mounted() {
    this.getTypeList()
  },
  methods: {
    changeType(value) {
      let params = {}
      if (value && value.length > 0) {
        params[this.feild] = value[value.length - 1]
      } else {
        params[this.feild] = undefined
      }
      this.$emit('changeForm', params)
    },
    getTypeList(parentId = 0, record) {
      // 获取片区id
      let obj = window.localStorage.getItem('factoryDetail')
      let factoryDetail = obj ? JSON.parse(obj) : {}
      let { deptId } = factoryDetail

      this.$get(
        `/nhf-core-data/basictype/listByParentIdWithOutSpecialTypeIdAndSatlimit?category=${this.category ? this.category : 'raw'}&parentId=${parentId}&deptId=${deptId}`
      )
        .then((res) => {
          let { success, data = [] } = res;
          if (success) {
            data &&
              data.map((el) => {
                el.value = el.id;
                el.label = el.name;
                el.isLeaf = !el.hasChildren;
                // el.isLeaf = false
                return el;
              });
            if (record) {
              if (data.length) {
                record.children = data;
              } else {
                record.isLeaf = true;
              }
              this.typeList = [...this.typeList];
            } else {
              this.typeList = data;
            }
          } else {
            this.typeList = [];
          }
        });
    },
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      setTimeout(() => {
        targetOption.loading = false;
        // this.$emit('getTypeList',{targetOption,id:targetOption.id})
        this.getTypeList(targetOption.id, targetOption);
      }, 0);
    },
  }
}
</script>